<script lang="ts">
	import { onMount } from 'svelte';

	let showBanner = $state(false);

	onMount(() => {
		const consent = localStorage.getItem('cookie-consent');
		if (!consent) {
			showBanner = true;
		} else if (consent === 'accepted') {
			loadGoogleAds();
		}
	});

	function accept() {
		localStorage.setItem('cookie-consent', 'accepted');
		showBanner = false;
		loadGoogleAds();
	}

	function reject() {
		localStorage.setItem('cookie-consent', 'rejected');
		showBanner = false;
	}

	// Un lien de partage porte un jeton secret dans l'URL (/s/<jeton>, puis
	// ?redirect=%2Fs%2F<jeton> pendant l'inscription) : Google Ads n'a pas à le recevoir.
	function sansJeton(url: string) {
		return url.replace(/(\/s\/|%2Fs%2F)[A-Za-z0-9_-]+/gi, '$1jeton');
	}

	function loadGoogleAds() {
		if (typeof window !== 'undefined' && (window as any).gtag) return;
		const script1 = document.createElement('script');
		script1.async = true;
		script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17758186695';
		document.head.appendChild(script1);
		const script2 = document.createElement('script');
		script2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());`;
		document.head.appendChild(script2);
		(window as any).gtag('config', 'AW-17758186695', {
			page_location: sansJeton(location.href),
			page_referrer: sansJeton(document.referrer)
		});
	}
</script>

{#if showBanner}
	<div class="fixed bottom-0 left-0 right-0 z-50 border-t border-mist bg-paper/95 p-4 backdrop-blur-sm md:p-5">
		<div class="mx-auto flex max-w-5xl flex-col gap-4 md:flex-row md:items-center md:gap-8">
			<div class="flex-1">
				<p class="text-sm font-semibold text-ink">Cookies et confidentialité</p>
				<p class="mt-1 text-sm leading-relaxed text-ash">
					Nous utilisons des cookies pour mesurer l'efficacité de nos publicités.
					<a href="/legal" class="text-encre underline-offset-2 hover:underline">En savoir plus</a>
				</p>
			</div>
			<div class="flex shrink-0 items-center gap-4">
				<button
					class="text-sm text-ash transition-colors hover:text-ink"
					onclick={reject}
				>
					Refuser
				</button>
				<button
					class="btn-relief px-5 py-2 text-sm font-semibold"
					onclick={accept}
				>
					Accepter
				</button>
			</div>
		</div>
	</div>
{/if}
